import * as React from 'react';
import type { QueryResult } from 'react-apollo';
import { Query } from 'react-apollo';

import GetXapiIntegration from 'bundles/enterprise-admin-xapi/components/GetXapiIntegration.graphql';
import type {
  GetXapiIntegrationQueryVariables,
  GetXapiIntegrationQuery as Response,
} from 'bundles/enterprise-admin-xapi/components/__generated__/GetXapiIntegration';

type Props = {
  variables: GetXapiIntegrationQueryVariables;
  children: (result: QueryResult<Response, GetXapiIntegrationQueryVariables>) => React.ReactElement | null;
};

const GetXapiIntegrationQueryWrapper: React.FC<Props> = ({ variables, children }) => {
  return (
    <Query<Response, GetXapiIntegrationQueryVariables>
      query={GetXapiIntegration}
      variables={variables}
      context={{ clientName: 'gatewayGql' }}
      errorPolicy="all"
    >
      {children}
    </Query>
  );
};

export default GetXapiIntegrationQueryWrapper;
